var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-size page-langues"},[_c('page-corners'),_c('div',[_c('h2',[_vm._v(" Avy any amin’ny foko mankany amin’ny fanjakana")]),_c('languages')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }